import { initializeApp } from "firebase/app";

const firebaseConfig = {
    apiKey: "AIzaSyA-nKALghAH3EqHNwgYBt-mgzyrO6ykI3s",
    authDomain: "makeup-artist-d21b7.firebaseapp.com",
    projectId: "makeup-artist-d21b7",
    storageBucket: "makeup-artist-d21b7.firebasestorage.app",
    messagingSenderId: "374015655443",
    appId: "1:374015655443:web:002eb398b2bd34ec1b89e6"
};

const firebaseApp = initializeApp(firebaseConfig);

export default firebaseApp;
